import {apiPostCall} from "./index";

export const send   = contactDetails => apiPostCall("/contact/send", {...contactDetails});
